var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraPortrait = function SvgCameraPortrait(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.333 3.492v2.105h-3.158v3.158H15.07V5.597h-3.158V3.492h3.158V.334h2.105v3.158zm-8.947 7.368a1.58 1.58 0 1 0-.001-3.159 1.58 1.58 0 0 0 0 3.16m3.684 3.405-.54-.6a2.105 2.105 0 0 0-3.132 0l-.69.768-5.112-5.678-3.157 3.508V5.598h7.368V3.492H2.439A2.105 2.105 0 0 0 .333 5.597V18.23c0 1.163.942 2.105 2.106 2.105H15.07a2.105 2.105 0 0 0 2.105-2.105V10.86H15.07z"
  })));
};
export default SvgCameraPortrait;